module.exports = __webpack_public_path__ + "img/collection-memoireRingsSignature.ca18f14.jpg";